import { render } from "./EditorialB.vue?vue&type=template&id=3e1978be&scoped=true"
import script from "./EditorialB.vue?vue&type=script&lang=js"
export * from "./EditorialB.vue?vue&type=script&lang=js"

import "./EditorialB.vue?vue&type=style&index=0&id=3e1978be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1978be"]])

export default __exports__